import { render, staticRenderFns } from "./studentFormFillUpFeeHistory.vue?vue&type=template&id=01dd6e06&"
import script from "./studentFormFillUpFeeHistory.vue?vue&type=script&lang=js&"
export * from "./studentFormFillUpFeeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports